// extracted by mini-css-extract-plugin
module.exports = {"section":"banner-module--section--lvoIJ","wrapper":"banner-module--wrapper--ZH4ZA","bannerImg":"banner-module--bannerImg--1JCLe"};